import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue')
  },
  {
    path: '/guide/home',
    name: 'GuideHome',
    meta: { title: '导览首页' },
    component: () => import(/* webpackChunkName: "GuideHome" */ '../views/guide/home/Home.vue')
  },
  {
    path: '/guide/floor/:id',
    name: 'GuideFloor',
    component: () => import(/* webpackChunkName: "GuideFloor" */ '../views/guide/floor/Floor.vue')
  },
  {
    path: '/guide/guidemap',
    name: 'GuideMap',
    component: () => import(/* webpackChunkName: "GuideMap" */ '../views/guide/guidemap/GuideMap.vue')
  },
  {
    path: '/musicList',
    name: 'musicList',
    component: () => import(/* webpackChunkName: "musicList" */ '../views/guide/musicList.vue')
  },
  {
    path: '/voiceExplain',
    name: 'voiceExplain',
    component: () => import(/* webpackChunkName: "voiceExplain" */ '../views/guide/voiceExplain.vue')
  },
  // exhibit 展览模块 start
  {
    path: '/exhibit/exhibitlist-old',
    name: 'ExhibitList',
    meta: { title: '线上展览', hideBack: true },
    component: () => import(/* webpackChunkName: "ExhibitList" */ '../views/exhibit/exhibitList/ExhibitList.vue')
  },
  // 新线上展览
  {
    path: '/exhibit/exhibitlist',
    name: 'ExhibitList',
    meta: { title: '线上展览', hideBack: true },
    component: () => import(/* webpackChunkName: "ExhibitList" */ '../views/exhibit/exhibitList/index.vue')
  },

  {
    path: '/exhibit/videoOnline',
    name: 'VideoOnline',
    meta: { title: '视频在线', hideBack: true },
    component: () => import(/* webpackChunkName: "VideoOnline" */ '../views/exhibit/videoOnline/VideoOnline.vue')
  },
  {
    path: '/exhibitSwiper-old',
    name: 'exhibitSwiper',
    meta: { hideBack: true },
    component: () => import(/* webpackChunkName: "exhibitSwiper" */ '../views/exhibit/exhibitSwiper/index.vue')
  },
  // 新正在展览|临时展览
  {
    path: '/exhibitSwiper',
    name: 'ExhibitCurrentIndex',
    meta: { title: '正在展览', hideBack: true },
    component: () => import(/* webpackChunkName: "ExhibitList" */ '../views/exhibit/exhibitSwiper/current/index.vue')
  },
  // 晋界讲坛
  {
    path: '/lecture',
    name: 'LectureIndex',
    meta: { title: '晋界讲坛', hideBack: true },
    component: () => import(/* webpackChunkName: "ExhibitList" */ '../views/lecture/index.vue')
  },
  // 看晋魂
  {
    path: '/jin-hun',
    name: 'JinHun',
    meta: { title: '看晋魂', hideBack: true },
    component: () => import(/* webpackChunkName: "LookJinSoul" */ '../views/jin-hun/index.vue')
  },
  // 山河永固
  {
    path: '/shyg',
    name: 'Shyg',
    meta: { title: '山河永固', hideBack: true },
    component: () => import(/* webpackChunkName: "Shyg" */ '../views/shyg/index.vue')
  },
  // 毕加索 达利与超现实主义艺术
  {
    path: '/bjs',
    name: 'Bjs',
    meta: { title: '毕加索 达利与超现实主义艺术', hideBack: true },
    component: () => import(/* webpackChunkName: "Bjs" */ '../views/bjs/index.vue')
  },
  {
    path: '/exhibitSwiperDitile/:id',
    name: 'exhibitSwiperDitile',
    component: () => import(/* webpackChunkName: "exhibitSwiperDitile" */ '../views/exhibit/exhibitSwiper/exhibitSwiperDitile.vue')
  },
  // exhibit 展览模块 end
  // cultural 其他的文物模块 start
  {
    path: '/culturalRelic',
    name: 'culturalRelic',
    meta: { hideBack: true },
    component: () => import(/* webpackChunkName: "culturalRelic" */ '../views/others/culturalRelic/index.vue')
  },
  {
    path: '/culturalRelic/notice',
    name: 'CulturalRelicNotice',
    meta: { title: '活动须知' },
    component: () => import(/* webpackChunkName: "CulturalRelicNotice" */ '../views/others/culturalRelic/Notice.vue')
  },
  {
    path: '/culturalRelic/promise',
    name: 'promise',
    meta: { title: '承诺书' },
    component: () => import(/* webpackChunkName: "CulturalRelicNotice" */ '../views/others/culturalRelic/promise.vue')
  },
  {
    path: '/culturalRelic/signUpNotice/:id',
    name: 'CulturalRelicSignUpNotice',
    meta: { title: '活动报名' },
    component: () => import(/* webpackChunkName: "CulturalRelicSignUpNotice" */ '../views/others/culturalRelic/SignUpNotice.vue')
  },
  {
    path: '/culturalRelic/signUp/:id',
    name: 'CulturalRelicSignUp',
    meta: { title: '活动报名' },
    component: () => import(/* webpackChunkName: "CulturalRelicSignUp" */ '../views/others/culturalRelic/SignUp.vue')
  },
  {
    path: '/culturalRelic/signUpResult/:id',
    name: 'CulturalRelicSignResult',
    meta: { title: '活动报名' },
    component: () => import(/* webpackChunkName: "CulturalRelicSignResult" */ '../views/others/culturalRelic/SignResult.vue')
  },
  {
    path: '/volunteer',
    name: 'VolunteerIndex',
    meta: { title: '志愿者', hideBack: true },
    component: () => import(/* webpackChunkName: "VolunteerIndex" */ '../views/others/volunteer/index.vue')
  },
  {
    path: '/volunteer/signUp',
    name: 'VolunteerSignUp',
    meta: { title: '志愿者报名' },
    component: () => import(/* webpackChunkName: "VolunteerSignUp" */ '../views/others/volunteer/SignUp.vue')
  },
  {
    path: '/volunteer/signUpResult',
    name: 'VolunteerSignResult',
    meta: { title: '志愿者报名' },
    component: () => import(/* webpackChunkName: "VolunteerSignResult" */ '../views/others/volunteer/SignResult.vue')
  },
  {
    path: '/volunteer/review',
    name: 'VolunteerReview',
    meta: { title: '志愿者报名' },
    component: () => import(/* webpackChunkName: "VolunteerReview" */ '../views/others/volunteer/Review.vue')
  },
  {
    path: '/volunteer/richText/:id',
    name: 'VolunteerRichText',
    meta: { title: '' },
    component: () => import(/* webpackChunkName: "VolunteerRichText" */ '../views/others/volunteer/RichText')
  },
  {
    path: '/educational',
    name: 'Educational',
    meta: { title: '教育活动', hideBack: true },
    component: () => import(/* webpackChunkName: "Educational" */ '../views/others/educational')
  },
  {
    path: '/educational/review',
    name: 'EducationalReview',
    meta: { title: '往期回顾' },
    component: () => import(/* webpackChunkName: "EducationalReview" */ '../views/others/educational/Review')
  },
  {
    path: '/educational/classroom',
    name: 'EducationalClassroom',
    meta: { title: '在线课堂' },
    component: () => import(/* webpackChunkName: "EducationalClassroom" */ '../views/others/educational/OnlineClassroom')
  },
  {
    path: '/educational/signup',
    name: 'EducationalSignup',
    meta: { title: '报名' },
    component: () => import(/* webpackChunkName: "EducationalSignup" */ '../views/others/educational/Signup')
  },
  {
    path: '/educational/signup2',
    name: 'EducationalSignup2',
    meta: { title: '报名' },
    component: () => import(/* webpackChunkName: "EducationalSignup" */ '../views/others/educational/Signup2')
  },
  {
    path: '/culturalRelic/richText',
    name: 'culturalRelicRichText',
    meta: { title: '' },
    component: () => import(/* webpackChunkName: "exhibitVideo" */ '../views/others/culturalRelic/RichText')
  },
  {
    path: '/educational/signResult',
    name: 'EducationalSignResult',
    meta: { title: '报名' },
    component: () => import(/* webpackChunkName: "EducationalSignResult" */ '../views/others/educational/SignResult')
  },
  {
    path: '/educational/myResule',
    name: 'myResule',
    meta: { title: '我的报名' },
    component: () => import(/* webpackChunkName: "myResule" */ '../views/others/educational/myResule')
  },
  {
    path: '/educational/queryResule',
    name: 'queryResule',
    meta: { title: '报名查询' },
    component: () => import(/* webpackChunkName: "queryResule" */ '../views/others/educational/queryResule')
  },
  {
    path: '/download',
    name: 'Download',
    meta: { title: '下载' },
    component: () => import(/* webpackChunkName: "Download" */ '../views/download')
  },
  {
    path: '/Notice',
    name: 'Notice',
    meta: { title: '参观须知' },
    component: () => import(/* webpackChunkName: "Notice" */ '../views/visit/notice/index')
  },
  {
    path: '/RichText/:id',
    name: 'RichText',
    meta: { title: '' },
    component: () => import(/* webpackChunkName: "RichText" */ '../views/others/educational/RichText')
  },
  {
    path: '/video/:id',
    name: 'video',
    meta: { title: '' },
    component: () => import(/* webpackChunkName: "video" */ '../views/others/educational/video')
  },
  {
    path: '/exhibitRichText/:id',
    name: 'exhibitRichText',
    meta: { title: '' },
    component: () => import(/* webpackChunkName: "exhibitRichText" */ '../views/exhibit/exhibitRichText/exhibitRichText')
  },
  {
    path: '/relicsRichText/:id',
    name: 'relicsRichText',
    meta: { title: '' },
    component: () => import(/* webpackChunkName: "relicsRichText" */ '../views/exhibit/relicsRichText/relicsRichText')
  },
  {
    path: '/exhibitVideo',
    name: 'exhibitVideo',
    meta: { title: '' },
    component: () => import(/* webpackChunkName: "exhibitVideo" */ '../views/exhibit/video/video')
  },
  {
    path: '/three',
    name: 'three',
    meta: { title: '', isOpen: true },
    component: () => import(/* webpackChunkName: "exhibitVideo" */ '../views/three')
  },
  {
    path: '/culturalRelic/queryResule',
    name: 'culturalRelicQueryResule',
    meta: { title: '' },
    component: () => import(/* webpackChunkName: "culturalRelicQueryResule" */ '../views/others/culturalRelic/queryResule')
  },
  {
    path: '/culturalRelic/SignResults/:id',
    name: 'culturalRelicSignResults',
    meta: { title: '' },
    component: () => import(/* webpackChunkName: "culturalRelicSignResults" */ '../views/others/culturalRelic/SignResults')
  },
  {
    path: '/culturalRelic/myResule',
    name: 'culturalRelicMyResule',
    meta: { title: '' },
    component: () => import(/* webpackChunkName: "culturalRelicMyResule" */ '../views/others/culturalRelic/myResule')
  },
  {
    path: '/educational/activityRegistration',
    name: 'activityRegistration',
    meta: { title: '' },
    component: () => import(/* webpackChunkName: "activityRegistration" */ '../views/others/educational/activityRegistration')
  },
  {
    path: '/educational/activityRegistration2',
    name: 'activityRegistration2',
    meta: { title: '' },
    component: () => import(/* webpackChunkName: "activityRegistration" */ '../views/others/educational/activityRegistration2')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '山西博物院'
  next()
})

export default router
